export default {
  RapidRewardsNumberFormField__ARIA: "Rapid Rewards number or Account number",
  RapidRewardsNumberFormField__LABEL: "Rapid Rewards®/Account #",
};
